<template>
  <div>
    <!-- <app-overlay-loader v-if="preloader" /> -->
    <div style="text-align: end">
      <button
        type="button"
        class="btn btn-primary btn-with-shadow mb-3"
        data-toggle="modal"
        @click="openAddEditModal"
      >
        {{ $t("assign_bid_form") }}
      </button>
    </div>

    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>

    <!-- <div class="card card-with-shadow border-0 h-100">
      <div class="card-body">
        <form
          ref="form"
          data-url="/crud"
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <table class="table">
                <tr>
                  <th>Company Name</th>
                  <th v-for="(formBody, index) in formBodies" :key="index">
                    {{ formBody.label }}
                  </th>
                  <th>Action</th>
                </tr>
                <tr
                  v-for="(formresponse, newIndex) in formResponses"
                  :key="newIndex"
                >
                  <template v-for="(new_res, indexName) in formresponse">
                    <td :key="indexName" v-if="indexName !== 'user_id'">
                      <p>{{ new_res }}</p>
                    </td>
                  </template>
                  <td>
                    <button
                      type="button"
                      v-on:click="
                        acceptForm(formResponses[newIndex]['user_id'])
                      "
                      class="btn btn-sm btn-success"
                    >
                      Accept
                    </button>
                    <button
                      type="button"
                      v-on:click="
                        rejectForm(formResponses[newIndex]['user_id'])
                      "
                      class="btn btn-sm btn-danger"
                    >
                      Reject
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div> -->
    <job-bidaddmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>
<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_STORE,
  COMPANY_JOB_GET,
  JOB_BID_LISTING,
  JOB_BID_ACCEPT,
  JOB_CATEGORY_NAME,
  JOB_CHECK_ACCEPTED_SUPPLIER,
  COMPANY_JOB_BID,
  FORM_BODY,
  FORM_ACCEPT,
  FORM_REJECT,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";
import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "FormGrid",
  components: { CopyButton },
  mixins: [FormMixin],
  data() {
    return {
      // preloader: true,
      job: {},
      site: [],
      task: [],
      bids: {},
      myBid: {},
      acceptedBid: {},
      formBodies: {},
      formResponses: {},
      company_name: "",
      assignSupplier: [],
      isAddEditModalActive: false,
      seen: false,
      sitecreate: false,
      notNull: false,
      tabsHorizontal: [
        {
          icon: "users",
          name: "Pending",
          component: "job-bids-pending",
          permission: "",
        },
        {
          icon: "info",
          name: "Accepted",
          component: "job-bids-accepted",
          permission: "",
        },
        {
          icon: "link",
          name: "Rejected",
          component: "job-bids-rejected",
          permission: "",
        },
      ],
    };
  },
  methods: {
    // beforeSubmit() {
    //   this.preloader = true;
    // },
    // submit() {
    //   this.save(this.inputs);
    // },

    // afterSuccess(res) {
    //   this.$toastr.s(res.data.message);
    // },
    // afterFinalResponse() {
    //   this.preloader = false;
    //   this.inputs = {
    //     gender: "male",
    //   };
    // },
    // afterError(res) {
    //   this.$toastr.e(res.data.message);
    // },
    // clear() {
    //   this.inputs = {};
    //   this.fieldStatus = {
    //     isSubmit: false,
    //   };
    // },
    // addNewSite() {
    //   this.addSite();
    // },
    // popSite(index) {
    //   this.site.splice(index, 1);
    // },
    // addNewTask(id) {
    //   this.addTask(id);
    // },
    // storeSite() {
    //   axiosPost(COMPANY_JOB_SITE_STORE, this.site)
    //     .then((res) => {
    //       this.$toastr.s(res.data.message);
    //       this.site = [];
    //       this.seen = false;
    //       //   
    //     })
    //     .catch((errors) => {
    //       
    //     });
    // },
    // addSite() {
    //   this.site.push({
    //     job_id: this.job.id,
    //     title: "",
    //     description: "",
    //     assignment_structure: "",
    //     start_time: "",
    //     end_time: "",
    //     task: [],
    //   });
    // },
    // addTask(id) {
    //   this.site[id].task.push({
    //     title: "",
    //     description: "",
    //   });
    // },
    // getCustomerJob() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   //   
    //   axiosGet(COMPANY_JOB_GET + "/" + id)
    //     .then((response) => {
    //       //   
    //       this.job = response.data;
    //       
    //       //   this.titleinvoice = response.data.company_name;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // getBids() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_BID_LISTING + "/" + id)
    //     .then((res) => {
    //       this.bids = res.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    // assignedSupplier(id) {
    //   axiosGet(JOB_BID_ACCEPT + "/" + id)
    //     .then((res) => {
    //       this.assignSupplier = res.data;
    //       this.notNull = true;
    //       this.sitecreate = true;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // checkAssignedSupplier() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_CHECK_ACCEPTED_SUPPLIER + "/" + id)
    //     .then((res) => {
    //       this.assignSupplier = res.data;
    //       this.notNull = true;
    //       this.sitecreate = true;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    // assignedSupplier()
    // {
    //     // alert(id);
    //     this.assignSupplier = {
    //         'id':'1',
    //         'name':'Test'
    //     }
    //     this.sitecreate = true;
    //     // this.seen = true;
    //     // this.addSite();
    //     
    // },
    // getCategoryName() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_CATEGORY_NAME + "/" + id)
    //     .then((res) => {
    //       
    //       this.job.category = res.data;

    //       
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    // createsite() {
    //   this.seen = true;
    //   this.addSite();
    // },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    // getCompanyBid() {
    //   // alert(userList.company_id);
    //   axiosGet(COMPANY_JOB_BID + "/" + this.userList.company_id)
    //     .then((res) => {
    //       
    //       this.myBid = res.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    getBodies(id) {
      // this.preloader = true;
      axiosGet(FORM_BODY + "/" + id)
        .then((res) => {
          
          let body = JSON.parse(res.data.get_revision[0].get_bodies.body);
          this.formBodies = body[0].fields;
          this.formResponses = res.data.formResponses;
          //  
          this.company_name = res.data.company.company_name;
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    acceptForm(user_id) {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let id = split[6].split("?")[0];
      let input = {};
      input.job_id = id;
      input.user_id = user_id;
      axiosPost(FORM_ACCEPT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        });
    },

    rejectForm(user_id) {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let id = split[6].split("?")[0];
      let input = {};
      input.job_id = id;
      input.user_id = user_id;
      axiosPost(FORM_REJECT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        });
    },
  },
  mounted() {
    let myLocation = location.href;
    let split = myLocation.split("/");
    let id = split[6].split("?")[0];
    // this.getBids();
    // this.getCustomerJob();
    // this.checkAssignedSupplier();
    // this.getCategoryName();
    // this.getCompanyBid();
    this.getBodies(id);
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
